<template>
	<div id="gallery-area">

		<div class="row justify-content-center" v-if="gallery.elements.length">
			<div class="col-xl-10 col-xxl-8">
				<form @submit.prevent="submitSearch">
					<div class="row justify-content-center">
						<div class="col-md-6 form-group mt-4 mb-2 position-relative">
							<i class="fa fa-search position-absolute c-pointer" @click.prevent="submitSearch"></i>
							<input type="text" placeholder="Cerca il nome della tua scuola" class="form-control form-control-lg pe-4 rounded-pill" style="border:1px solid #439A00 !important;" v-model="gallery.search">
						</div>

						<div class="col-md-6 form-group mt-4 mb-1 position-relative">
							<select id="referente" name="referente" class="form-select form-select custom-select d-block rounded-pill" style="border:1px solid #439A00 !important;" v-model="gallery.ordine" @change.prevent="changeSchoolOrder">
								<option value="" class="placeholder">Seleziona ordine scuola</option>
								<option value="primaria">Scuola primaria</option>
								<option value="secondaria">Scuola secondaria I grado</option>
							</select>
						</div>
					</div>
				</form>
			</div>
		</div>

		<transition name="fade">
			<div id="gallery-container" class="row pt-3 justify-content-center" v-if="gallery.elements.length">
				<div class="col-11 col-sm-10 col-md-6 col-lg-4 col-xl-4 mb-5 position-relative c-pointer" v-for="(work, index) in gallery.elements" :key="index" @click.prevent="showWork(work.url_media, `<div class='fs-1-3 text-white bold'><span>` + work.classe + work.sezione + `</span> - <span>` + work.nome + `</span></div><div class='fs-1-3 text-white bold'><span>` + work.citta + ` (` + work.provincia + `)</span></div>`, `<p class='mb-0'>` + work.text + `</p>`, work.sfondo)">
					<div class="row px-3">
						<div class="col-12" style="border-radius:13px;overflow:hidden;">
							<div class="row">

								<div class="col-12 position-relative px-0">
									<div class="frame-container">
										<div class="frame-square p-3" :class="work.sfondo">
											<img :src="work.url_media" class="img-fluid w-100">
										</div>
									</div>
								</div>

								<div class="col-12 text-center text-white bold px-0" style="line-height:1.3;">
									<div class="pt-0 pb-3 px-3" :class="work.sfondo">
										<div class="fs-1-3">
											<span>{{work.classe}}{{work.sezione}}</span> - <span>{{work.nome}}</span>
										</div>
										<div class="fs-1-3 did-gallery">
											<span>{{work.citta}} ({{ work.provincia }})</span>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<div id="gallery-container" class="row pt-5 justify-content-center align-items-center mb-5 empty-gallery mt-5" v-if="!gallery.elements.length && gallery.showMsg === true">
			<div class="col-sm-10 text-center" v-if="gallery.search == ''">
				<p class="fs-2 lh-1-3" v-if="workType == 'secondary'">Il progetto è iniziato da poco: gli studenti si stanno mettendo in gioco!</p>
				<p class="fs-2 lh-1-3" v-if="workType == 'primary'">Il progetto è iniziato da poco: gli studenti stanno ideando il loro "Manifesto <i>Stammi Bene!</i>"</p>
			</div>
			<div class="col-sm-10 text-center" v-else>
				<p class="fs-2">Non ci sono contributi che corrispondono alla ricerca effettuata.</p>
				<button class="btn btn-green btn-lg rounded-0 px-5 py-2 mt-2 bold" @click.prevent="onResetSearch">
					<span class="va-sub">RESET</span>
				</button>
			</div>
		</div>

		<div class="row justify-content-center">
			<div class="col-12">
				<pagination
					v-model="gallery.pageNo"
					:records="parseInt(gallery.totElements)"
					:per-page="perPage"
					:options=optionsPag
					@paginate="getGalleryElements"
				></pagination>
			</div>
		</div>

		<modal
			:name="modalId"
			height="auto"
			:adaptive="false"
			:width="maxModalWidth"
			:scrollable="true"
			classes="modal-override"
			:id="modalId"
		>
			<div class="modal-header text-end bg-transparent p-0 justify-content-end border-0 lh-1 rounded-0">
				<button type="button" class="px-0 pt-0 pb-2 bold border-0 bg-transparent text-white rounded-0" data-dismiss="modal" aria-label="Close" @click.prevent="$modal.hide(modalId)">
					<i class="fas fa-times hover-default fs-2-5"></i>
				</button>
			</div>
			<div class="img-modal px-4 pt-4 pb-2 m-0" :class="this.modal.color">
				<img :src="modal.img" alt="gallery" class="img-fluid w-100 pt-2">
			</div>
			<div class="text-center mb-4 did-section" :class="this.modal.color">
				<div class="pt-2 pb-3 px-3 fs-1-3 text-center font-family-caveat" v-html="modal.html"></div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import Pagination from 'vue-pagination-2'
import CustomPagination from './CustomPagination.vue'

export default {
	props: ['perPage', 'themaUrl', 'workType', 'didColor', 'action', 'modalId'],
	components: {Pagination},

	data() {
		return {
			urlHost: this.themaUrl,
			ajaxObj: window.ajax_object,
			themeUrl: this.themaUrl,
			worksDir: this.urlHost + 'wp-content/uploads/works/',
			bgUrl: '',
			gallery: {
				xpage: this.perPage,
				pageNo: 1,
				totElements: 0,
				search: '',
				ordine: '',
				elements: [],
				showMsg: false,
				isEnd: false
			},
			modal: {
				img: '',
				color: '',
				html: '',
				htmlDid: ''
			},
			isLoading: false,
			maxModalWidth: window.outerWidth <= 700 ? (window.outerWidth - 100) : 700,
			optionsPag: {
				chunk: 6,
				texts: {
					count: "pagina {page} di {pages}",
				},
				template: CustomPagination
			}
		}
	},

	methods: {
		getGalleryElements() {
			this.isLoading = true
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', this.action)
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('xpage', this.gallery.xpage)
			formData.append('current_page', this.gallery.pageNo)
			formData.append('work_type', this.workType)
			formData.append('search', this.gallery.search)
			formData.append('ordine', this.gallery.ordine)

			axios.post(url, formData)
				.then((response) => {
					let _this = this
					_this.gallery.totElements = response.data.tot_works
					//console.log(response.data)
					this.gallery.showMsg = false
					if (response.data.gallery_elements.length) {

						// let galleryElTmp = _this.gallery.elements
						_this.gallery.showMsg = false
						_this.gallery.elements = []
						setTimeout(function() {
							// _this.gallery.elements = galleryElTmp.concat(response.data.gallery_elements)
							_this.gallery.elements = response.data.gallery_elements
						}, 250, _this);
					} else {
						this.gallery.showMsg = true
					}

					this.isLoading = false
					this.gallery.isEnd = response.data.disable_btn == 1 ? true : false
				}, (error) => {
					this.isLoading = false
					console.log(error);
				});
		},

		gallerySearch() {
			this.gallery.pageNo = 1
			this.gallery.elements = []
			this.getGalleryElements()
		},

		onResetSearch() {
			this.gallery.search = ''
			this.gallerySearch()
		},

		loadMore() {
			this.gallery.pageNo = this.gallery.pageNo + 1
			this.getGalleryElements()
		},

		paginationCallBack(page) {
			this.pageNo = page
			this.getGalleryElements()
		},

		showWork(img, html, htmlDid, color) {
			this.modal.color = color
			this.modal.img = ''
			this.modal.html = ''
			this.modal.img = img
			this.modal.html = html
			this.modal.htmlDid = htmlDid
			this.$modal.show(this.modalId)
		},

		submitSearch() {
			this.gallery.pageNo = 1
			this.gallery.elements = []
			this.getGalleryElements()
		},

		changeSchoolOrder() {
			this.gallery.pageNo = 1
			this.gallery.elements = []
			this.getGalleryElements()
		}
	},

	mounted() {
		this.getGalleryElements()
	}

}
</script>

<style scoped>
.vid-container {
	width: 100%;
	padding-top: 100%;
	position: relative;
	background-color: transparent;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
}
.vid-inner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 1% 5%;
}
.camera {
	position: absolute;
	max-width: 64px;
	bottom: 15px;
	right: 15px;
	cursor: pointer;
}
.form-control {background-color: #ffffff;}
.square {
	overflow: hidden;
}
.square::after {
	content: "";
	display: block;
	padding-bottom: 100%;
}
.square-inner {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
}
.square-inner > img {
	object-fit: cover;
	object-position: center;
	width: 100%;
	height: 100%;
}
.zoom-ico {
	position: absolute;
	top: 10px;
	right: 10px;
	max-width: 50px;
	opacity: .8;
	cursor: pointer;
}
.bi-arrow-repeat.rotating {
	display: none;
	vertical-align: text-bottom;
}
i.fa-search {
    font-size: 1.3rem;
    color: #333;
    top: 50%;
    right: 1.25rem;
	transform: translateY(-50%);
}
</style>

<style scoped>
.img-modal {
	border-top-left-radius: 13px;
	border-top-right-radius: 13px;
}
.did-section {
	border-bottom-left-radius: 13px;
	border-bottom-right-radius: 13px;
}
.vm--modal {
	border-radius: 0 !important;
}
.form-select {
	border-radius: 9px;
	border: 2px solid #000 !important;
	min-height: calc(1.5em + 1.30rem);
	color: #000 !important;
	font-weight: 400;
}
</style>
